module.exports = __webpack_public_path__ + "media/images/favicons/tastee-society/apple-touch-icon-1e6e197e3e2964aa718a1ee6df2cb237.png";